module.exports = __webpack_public_path__ + "img/3-5.3eb36c53.svg";